import '@angular/localize/init';
export * from './lib/feature-tax-tasks-details.module';

export * from './lib/tax-tasks-details/feature-tax-tasks-details.component';
